import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@bookly/shared';

export interface FavoriteRoomDto {
  id: string;
  roomDexId: string;
  userEmail: string;
}

@Injectable({
  providedIn: 'root',
})
export class FavoriteApiService {
  readonly #http = inject(HttpClient);
  readonly #favoritesUrl = environment.user.favoritesApi;

  public addFavorite(roomDexId: string): Observable<FavoriteRoomDto> {
    return this.#http.post<FavoriteRoomDto>(this.#favoritesUrl, { roomDexId });
  }

  public removeFavorite(roomDexId: string): Observable<void> {
    return this.#http.delete<void>(`${this.#favoritesUrl}/${roomDexId}`);
  }

  public listFavorites(): Observable<FavoriteRoomDto[]> {
    return this.#http.get<FavoriteRoomDto[]>(this.#favoritesUrl);
  }
}
